import React from 'react';
import { Input, WindowedTable as Table } from '@economic/taco';
import useQuery from '../shared/hooks/useQuery';
import { ViewProps } from './types';
import { t } from '../shared/components/l10n/l10n';
import View, { useViewFilter } from '../shared/components/View/View';
import { useTableSortPreferences } from '../shared/hooks/useTableSortPreference';

interface CustomersViewProps extends ViewProps {
    customerNumber: number;
}

export default function CustomerContactsView({
    onCreated: handleCreated,
    onSelected: handleSelected,
    customerNumber,
}: CustomersViewProps) {
    const contactsQuery = useQuery(`/customers/contacts/${customerNumber}`, []);
    const [filter, setFilter, filterBy] = useViewFilter();
    const tableSort = useTableSortPreferences('customerContacts');

    return (
        <View>
            <View.Title>{t`FORM_CONTACTS_HEADLINE`}</View.Title>

            <View.Header>
                <View.Header.Filters>
                    <Input
                        autoFocus
                        onChange={event => setFilter(event.target.value)}
                        placeholder={t`FORM_LISTVIEW_FILTER_PLACEHOLDER`}
                        type="search"
                        value={filter}
                    />
                </View.Header.Filters>
            </View.Header>

            <View.Content>
                <Table
                    {...tableSort}
                    autoFocus
                    data={contactsQuery.data.filter(contact => filterBy(contact.name) || filterBy(contact.userInterfaceId))}
                    onRowClick={row => handleSelected(row.values)}>
                    <Table.Column
                        accessor="userInterfaceId"
                        headRenderer={t`FORM_FIELD_LABEL_NUMBER`}
                        flex="0 0 75px"
                        sort="asc"
                    />
                    <Table.Column accessor="name" align="left" headRenderer={t`FORM_FIELD_LABEL_NAME`} />
                </Table>
            </View.Content>
        </View>
    );
}
